import { render, staticRenderFns } from "./BookingSelector.vue?vue&type=template&id=90e25c10&scoped=true"
import script from "./BookingSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e25c10",
  null
  
)

export default component.exports